module.exports = __webpack_public_path__ + "static/media/info.a9f70138.svg";